import { Injectable } from '@angular/core';
import {Lab} from './lab';
import {LABS} from './mock-labs';

@Injectable({
  providedIn: 'root'
})
export class LabService {
  public  curLab :Lab;
  public getCurLab(){
    return this.curLab;
  }
  public setCurLab(id:number){
    this.curLab = this.getLab(id);
  }
  constructor() {

  }

  getLabs():Lab[]{
    return LABS;
  }

  getLab(labId: number) {
    return LABS[labId-1];
  }
  getTask(taskId:number){
    // return this.curLab[taskId-1];
  }
}
